export class SelectedPortfolioIndexState {
	public selectedPortfolioIndex: number = 0;
}
